import { render, staticRenderFns } from "./enrolments.html?vue&type=template&id=96e1cf08&scoped=true&external"
import script from "./enrolments.vue?vue&type=script&lang=ts"
export * from "./enrolments.vue?vue&type=script&lang=ts"
import style0 from "./enrolments.scss?vue&type=style&index=0&id=96e1cf08&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e1cf08",
  null
  
)

export default component.exports